import script from "./AppTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTabs.vue?vue&type=script&setup=true&lang=js"

import "./AppTabs.vue?vue&type=style&index=0&id=33a8d5a2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33a8d5a2"]])

export default __exports__